// extracted by mini-css-extract-plugin
export default {"outerTabsContainer":"Tabs_outerTabsContainer__4qmGo","innerTabsContainer":"Tabs_innerTabsContainer__53LJh","tabsBottomBorder":"Tabs_tabsBottomBorder__FtpE0"};